import React from "react";
import { Document } from "@react-pdf/renderer";
import { SLIDE_TYPES } from "../constants/slideTypes";
import defaultVanImage from "../assets/transportBg.jpg";
import vanImage from "../assets/van.png";
import starIcon from "../assets/star.png";
import headerIcon from "../assets/frontCar.png";
import flightIcon from "../assets/flightIcon.png";
import fixedIcon from "../assets/carFixedIcon.png";
import hotelIcon from "../assets/hotelIcon.png";
import CoverSlide from "./slides/CoverSlide";
import TransportSlide from "./slides/TransportSlide";
import FlightSlide from "./slides/FlightSlide";
import InclusionSlide from "./slides/InclusionSlide";
import ExclusionSlide from "./slides/ExclusionsSlide";
import HotelSlide from "./slides/HotelSlide";
import ItinerarySlide from "./slides/ItinerarySlide";
import PaymentTermsPolicySlide from "./slides/PaymentTermsPolicySlide";
import TermsConditionsSlide from "./slides/TermsConditionsSlide";
import ThankYouSlide from "./slides/ThankYouSlide";

 

const PdfDocument = ({ slides }) => (
  <Document>
    {slides.map((slide) => {
      switch (slide.type) {
        case SLIDE_TYPES.COVER:
          return <CoverSlide key={slide.id} {...slide} />;

        case SLIDE_TYPES.ITINERARY:
          return (
            <ItinerarySlide
              key={slide.id}
              dayNumber={slide.dayNumber}
              title={slide.title}
              date={slide.date}
              points={slide.points}
              bg={slide.bg}
              icon={slide.icon}
            />
          );

        case SLIDE_TYPES.TRANSPORT: {
          const transport = slide.transportOptions?.[0] || {};
          const details = transport.details || {};
          const points = transport.points || [];

          return (
            <TransportSlide
              key={slide.id}
              bg={slide.bg}
              title={slide.title}
              subtitle={slide.subtitle}
              vehicleImg={transport.vehicleImage || defaultVanImage}
              vanImage={transport.vanImage || vanImage}
              details={details}
              points={points}
              starIcon={starIcon}
              icon={headerIcon}
              fixedIcon={fixedIcon}
            />
          );
        }

        case SLIDE_TYPES.FLIGHTS:
          return (
            <FlightSlide
              key={slide.id}
              bg={slide.bg}
              title={slide.title}
              subtitle={slide.subtitle}
              flights={slide.flights}
              icon={flightIcon}
            />
          );

        case SLIDE_TYPES.INCLUSIONS:
          return (
            <InclusionSlide
              key={slide.id}
              bg={slide.bg}
              heading={slide.heading}
              inclusions={slide.points}
            />
          );

        case SLIDE_TYPES.EXCLUSIONS:
          return (
            <ExclusionSlide
              key={slide.id}
              bg={slide.bg}
              heading={slide.heading}
              exclusions={slide.exclusions} 
            />
          );

        case SLIDE_TYPES.HOTELS:
          return (
            <HotelSlide
              bg={slide.bg}
              icon={hotelIcon}
              title={slide.title}
              subtitle={slide.subtitle}
              hotelGroups={slide.hotelGroups}
            />
          );

        case SLIDE_TYPES.POLICY:
          return (
            <PaymentTermsPolicySlide
              bg={slide.bg}
              icon={slide.icon}
              heading={slide.heading}
              tagline={slide.tagline}
              policyGroups={slide.policyGroups}
            />
          );

        case SLIDE_TYPES.TERMS:
          return (
            <TermsConditionsSlide
              bg={slide.bg}
              icon={slide.icon}
              heading={slide.heading}
              tagline={slide.tagline}
              allTermsGroup={slide.allTermsGroup}
            />
          );

        case SLIDE_TYPES.THANKYOU:
          return (
            <ThankYouSlide
              bg={slide.bg}
              icon={slide.icon}
              title={slide.title}
              subtitle={slide.subtitle}
              thankyouGroup={slide.thankyouGroup}
            />
          );
        default:
          return <CoverSlide key={slide.id} {...slide} />;
      }
    })}
  </Document>
);

export default PdfDocument;
